import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { ImageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

export function getSelectedImage(state: ApplicationState, product: ProductModel | undefined) {
    const { selectedImageIndex } = state.pages.productDetails;

    if (product && selectedImageIndex === -2) {
        return {
            id: "360-image",
            imageAltText: "360 Image",
            imageType: "Custom360",
            largeImagePath: "",
            mediumImagePath: product?.properties["imagePath360"],
            name: "360 Image",
            smallImagePath: "",
            sortOrder: 999,
        } as ImageModel;
    }

    if (!product || !product.images || product.images.length <= selectedImageIndex) {
        return;
    }

    return product.images[selectedImageIndex];
}
